export type GlassNotificationTone = 'success' | 'error' | 'warning' | 'info' | 'loading';

/** Alineado con `UseToastOptions['status']` de Chakra. */
export function toastStatusToGlassTone(
  status: 'default' | 'success' | 'error' | 'warning' | 'info' | 'loading' | undefined
): GlassNotificationTone {
  switch (status) {
    case 'success':
      return 'success';
    case 'error':
      return 'error';
    case 'warning':
      return 'warning';
    case 'loading':
      return 'loading';
    case 'info':
    case 'default':
    default:
      return 'info';
  }
}
